import { FMSLocationData, FMSType, LocationVarInterface, LocationVarKey } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

//LINK - apps/server/src/API/Vars/LocationVars/LocationVars.Controller.ts
export class LocationVarsAPI {
  static async loadVariables(orgId: number): Promise<LocationVarInterface[]> {
    return APIService.Server.get<LocationVarInterface[]>(`/location-vars/org/${orgId}/all`);
  }

  static async getAllVariablesForKey(orgId: number, key: LocationVarKey): Promise<LocationVarInterface[]> {
    return APIService.Server.get<LocationVarInterface[]>(`/location-vars/org/${orgId}/all-for-key`, { key });
  }

  static async loadLocationVariables(orgId: number, keys: LocationVarKey[]): Promise<LocationVarInterface[]> {
    return APIService.Server.get<LocationVarInterface[]>(`/location-vars/org/${orgId}/locations/variables`, { keys });
  }

  static async createVariable(key: string, value: string, orgId: number, groupId?: number, locationId?: number) {
    return APIService.Server.post<LocationVarInterface>(`/location-vars/org/${orgId}/variable`, {
      key: key,
      value: value,
      groupId,
      locationId,
    });
  }

  static async updateVariable(orgId: number, variableId: number, value?: string) {
    return APIService.Server.put<LocationVarInterface>(`/location-vars/org/${orgId}/variable/${variableId}`, { value: value });
  }

  static async updateVariableByKey(orgId: number, locationId: number, key: string, value: string) {
    return APIService.Server.put<LocationVarInterface>(`/location-vars/org/${orgId}/location/${locationId}/variable/${key}`, { value: value });
  }

  static async deleteVariable(orgId: number, variableId: number) {
    return APIService.Server.delete(`/location-vars/org/${orgId}/variable/${variableId}`);
  }

  static async getFMSLocationData(fmsType?: FMSType) {
    return APIService.Server.get<FMSLocationData[]>(`/location-vars/location-data`, fmsType ? { fmsType } : undefined);
  }

  static async getVars<T extends LocationVarKey>(
    keys: T[],
    orgId: number,
    groupId?: number,
    locationId?: number,
  ): Promise<{ [K in T]: string | undefined }> {
    let payload: any = { keys };
    if (groupId) payload.groupId = groupId;
    if (locationId) payload.locationId = locationId;
    return APIService.Server.get<{ [K in T]: string | undefined }>(`/location-vars/org/${orgId}`, payload);
  }

  static async getVar(key: LocationVarKey, orgId: number, groupId?: number, locationId?: number): Promise<string | undefined> {
    return APIService.Server.get<string | undefined>(`/location-vars/org/${orgId}/var/${key}`);
  }

  static async getAllLocationVariables(orgId: number, keys: LocationVarKey[], includeLocation?: boolean): Promise<LocationVarInterface[]> {
    return APIService.Server.get<LocationVarInterface[]>(`/location-vars/org/${orgId}/locations/variables`, { keys, includeLocation });
  }

  static async getAllVariablesByValue(value: string): Promise<LocationVarInterface[]> {
    return APIService.Server.get<LocationVarInterface[]>(`/location-vars/value/${value}`);
  }
}
